import { render } from "./redirect.vue.js?vue&type=template&id=83a0ae7a!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./redirect.vue?vue&type=template&id=83a0ae7a"
import script from "./redirect.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./redirect.vue?vue&type=script&lang=js"
export * from "./redirect.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./redirect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__